import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Chart from 'react-apexcharts';
import { useAppSelector } from '../../../redux/storeExports'
import {ProfileSelectors} from "@meprism/shared/src/redux/profile/ProfileSlice";

interface ScanCoverageCardProps {
  cleanScans: number;
  totalBrokers: number;
}

const formatDate = (dateString?: string): string => {
   if (!dateString) return 'N/A'
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return 'Invalid Date'

  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })
}

const ScanCoverageCard: React.FC<ScanCoverageCardProps> = ({
  cleanScans,
  totalBrokers,
}) => {
  const progress = (cleanScans / totalBrokers) * 100;
  const profile = useAppSelector(ProfileSelectors.selectProfile);
  const lastScanStart = profile?.last_scan_initiated_at;
  return (
    <Card
      sx={{
        borderRadius: '16px',
        boxShadow: '0px 4px 10px rgba(208, 210, 218, 0.37)',
        height: 261,
        display: 'flex',
        justifyContent: 'center',
        minWidth: 320,
        background: '#FFFFFF',
      }}
    >
     <CardContent
        sx={{
            '&:last-child': { pb: 1 },
        }}
        >

        {/* Header */}
        <Box display="flex" justifyContent="center" sx={{ mb: 0, mt: 1.5 }}>
          <Typography
            sx={{
              fontFamily: 'InterSemiBold',
              fontSize: 18,
              fontWeight: 600,
              color: '#1A1B20',
            }}
          >
            Scan Coverage
          </Typography>
        </Box>

        {/* Semi-circle progress */}
        <Box position="relative" display="flex" justifyContent="center">
          <Chart
            options={{
              chart: { type: 'radialBar', 
                        sparkline: { enabled: true },
                        offsetY: -12,
                     },
              plotOptions: {
                radialBar: {
                  startAngle: -90,
                  endAngle: 90,
                  track: {
                    background: '#E3DEF7',
                    strokeWidth: '90%',
                  },
                  hollow: {
                    margin: 0,
                    size: '65%',
                    background: 'transparent',
                  },
                  dataLabels: {
                    show: false,
                  },
                },
              },
              fill: { 
                  colors: ['#7459D9'],
                  opacity: 1 
                },
              stroke: {
                lineCap: 'round',
              },
              labels: [],
            }}
            series={[progress]}
            type="radialBar"
            height={260}
            width={300}
          />
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            mt={6}
          >
            <Typography sx={{ fontSize: 32, fontWeight: 500, lineHeight: '0.7', fontFamily:'InterMedium', color: '#131313' }}>
              {cleanScans}
            </Typography>
             <Typography sx={{ fontSize: 16, fontWeight: 400, fontFamily:'InterRegular', color: '#131313' }}>
              Clean Scans
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display:'flex', flexDirection: 'column', alignItems: 'center', gap:1.5, color:"#000000"}}>
            <Typography sx={{fontFamily:"InterRegular", fontSize: 14, fontWeight:400}}>
                Your data was not found on these brokers.
            </Typography>
            {lastScanStart &&(
            <Typography sx={{fontFamily:"InterRegular", fontSize: 14, fontWeight:400, color: '#9135E0', textDecoration:'underline'}}>
                Latest scan: {formatDate(lastScanStart)}
            </Typography>
            )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ScanCoverageCard;
